import useModal from "../../useModal";
import UseContext from "../../../../hooks/useContext";
import Modalheader from "../../components/header";
import ModalBody from "../../components/body";
import ModalFooter from "../../components/footer";
import Button from "../../../../components/button";
import React, { useState } from "react";
import ApiDatabase from "../../../../server";

const ModalSendPinSms = () => {
  const { toggle } = useModal();
  const { modalData, setModalDataReturn } = UseContext();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const worker = modalData?.worker;
  const workerName = worker
    ? `${worker.firstname || ""} ${worker.lastname || ""}`.trim() || "l'employé"
    : "l'employé";
  const phone = worker?.phone || "—";

  const handleSubmit = () => {
    if (!worker?._id) return;
    setIsLoading(true);
    setError("");
    ApiDatabase.postSendWorkerPinSms(
      { id: worker._id },
      () => {
        setIsLoading(false);
        setModalDataReturn({ success: true, workerId: worker._id });
        toggle();
      },
      (err) => {
        setIsLoading(false);
        setError(
          err?.response?.data?.message ||
            "Une erreur est survenue lors de l'envoi du SMS."
        );
      }
    );
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        Confirmer l'envoi du PIN
      </Modalheader>
      <ModalBody>
        <div className="flex flex-col gap-2">
          <div className="text-gray-500">
            Êtes-vous sûr de vouloir envoyer le code PIN à <strong>{workerName}</strong> au
            numéro <strong>{phone}</strong> ?
          </div>
          {error && <div className="text-red-500 text-sm">{error}</div>}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button size="LG" color="SECONDARY" onClick={toggle}>
          Annuler
        </Button>
        {isLoading ? (
          <Button size="LG" color="DISABLED">
            Envoi en cours...
          </Button>
        ) : (
          <Button size="LG" onClick={handleSubmit}>
            Envoyer
          </Button>
        )}
      </ModalFooter>
    </>
  );
};

export default ModalSendPinSms;
